export type CareerPlanLatestTab = "goals" | "results" | "answers";

export function careerPlanLatestTabFromSearch(searchParams: URLSearchParams): CareerPlanLatestTab {
  const tab = searchParams.get("tab");
  if (tab === "results" || tab === "answers") return tab;
  return "goals";
}

export function careerPlanCompetencyIdFromSearch(searchParams: URLSearchParams): string | null {
  const competencyId = searchParams.get("competencyId")?.trim() ?? "";
  return competencyId || null;
}

export function careerPlanLatestSearchParams(
  tab: CareerPlanLatestTab,
  competencyId?: string | null
): Record<string, string> {
  if (tab === "goals") {
    return {};
  }

  if (tab === "answers" && competencyId) {
    return { tab, competencyId };
  }

  return { tab };
}

export function careerPlanLatestQueryString(tab: CareerPlanLatestTab, competencyId?: string | null): string {
  const params = new URLSearchParams(careerPlanLatestSearchParams(tab, competencyId));
  const query = params.toString();
  return query ? `?${query}` : "";
}

export function careerPlanLatestHref(pgaId: string, tab: CareerPlanLatestTab, competencyId?: string | null): string {
  return `/people/${pgaId}/career/career-profile/latest${careerPlanLatestQueryString(tab, competencyId)}`;
}
